import * as Device from "expo-device";
export const isDeviceVirtual = () => {
  //Device.isDevice doesn't work well on all android emulators
  //This is a workaround until issue gets resolved https://github.com/expo/expo/issues/16165
  if (
    Device.osName === "Android" &&
    (Device.osBuildFingerprint?.includes("emulator") ||
      Device.osBuildFingerprint?.includes("emu64"))
  ) {
    // console.log("Running on Android emulator");
    return true;
  } else {
    return !Device.isDevice;
  }
};
